/* eslint-disable */
export default {
  eula: 'Contrat de licence d’utilisateur final',
  eulaAbbr: 'CLUF',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
